import React from "react";
import * as styles from "./velavu-radio.module.scss";
import whitelabel from "../whitelabel";

//VelavuRadio is a simple non-interactive radio component for visibility purposes
export default function VelavuRadio(props: { checked: boolean }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
		>
			<circle
				cx="8"
				cy="8"
				r="6"
				stroke={whitelabel.palette.secondary700}
				strokeWidth="1.5"
				fill="none"
			/>
			<circle
				className={`${styles.circle} ${
					props.checked
						? styles.circleChecked
						: styles.circleUnchecked
				}`}
				cx="8"
				cy="8"
				r="3"
				fill={whitelabel.palette.secondary700}
			/>
		</svg>
	);
}
